import Vue from 'vue';
// tslint:disable-next-line:no-import-side-effect
import './plugins/vuetify';
import App from './App.vue';
// tslint:disable-next-line:no-import-side-effect
import './registerServiceWorker';
import router from './router';
// tslint:disable-next-line:no-import-side-effect
import 'roboto-fontface/css/roboto/roboto-fontface.css';
// tslint:disable-next-line:no-import-side-effect
import '@fortawesome/fontawesome-free/css/all.css';

Vue.config.productionTip = false;

new Vue({
	render: h => h(App),
	router,
}).$mount('#app');
